<template>
	<transition name = "fade">
		<div class="wallContainer" v-show="showWall">
			<div>
				<transition-group name="list">
					<div v-for="(wall) in walls" :key="wall" class="wallDiv">
						<router-link :to="{name: 'WallInfo', params: {clientId: wall}}">{{wall}}</router-link>
					</div>
				</transition-group>
				<div>
					<transition name="fade" @after-leave="postFormSubmit">
						<form @submit.prevent="submitWall" v-show="showWallSubmitForm" :class="{disabled: formDisableOverride}" >

							<input placeholder = "Name: Letters, numbers and dashes only" class="singleLineInput" type = "text" v-model="newWallName"/>
							<br/><br/>
							<div class = "buttonWrap">
								<button type = "submit" :disabled="submitDisabled">Submit</button>
								<button type = "reset" @click="showWallSubmitForm=false">Cancel</button>
							</div>
						</form>
					</transition>

					<transition name="fade" v-show="showWallSubmitButton" @after-leave="showWallSubmitForm = true"> 
						<div class="buttonWrap">
							<button @click="showWallSubmitButton=false; formDisableOverride=false" >
								New Wall
							</button>
						</div>
						
					</transition>
					
				</div>
			</div>
		</div>
	</transition>
</template>

<script>

import prayerService from "@/services/prayerService.js"
import {format, isSameDay} from 'date-fns';
import nameValidate from "/common/validation/clientNameValidation.js";

export default{
	name: "UserWalls",
	props: ["userId"],
	data: () =>{return {
		walls: [],
		newWallName: "",
		submitDisableOverride: false,
		formDisableOverride: false,
		showWall: false,
		showWallSubmitForm: false,
		showWallSubmitButton:true
	}},
	async mounted(){
		await this.refreshWalls();
		this.showWall = true;
	},
	methods: {
		async submitWall(){
			this.formDisableOverride = true;
			await prayerService.postWall(this.userId, this.newWallName, this.$store.state.userToken);
			this.showWallSubmitForm = false;

		},

		async refreshWalls(){
			await prayerService.getWalls(this.userId).then(walls => {
			
				let sortedWalls = walls.sort();
				this.walls = sortedWalls;

			})
		},

		async postFormSubmit(){
			await this.refreshWalls();
			this.showWallSubmitButton = true;
			this.newWallName = ""
		}
	},

	computed: {
		submitDisabled(){
			return !this.newWallName || this.submitDisableOverride || !nameValidate(this.newWallName)
		}
	}
}
</script>


<style scoped>

@font-face { font-family: "Roboto Condensed"; src: url("https://fonts.gstatic.com/s/robotocondensed/v19/ieVl2ZhZI2eCN5jzbjEETS9weq8-19K7DQ.woff2") format("woff2"); font-style: normal; font-weight: 400; unicode-range: U+0-FF, U+131, U+152-153, U+2BB-2BC, U+2C6, U+2DA, U+2DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD; }

.wallContainer{
	font-weight: 700;
	font-style: normal;
	font-family: 'Roboto Condensed', sans-serif;
	font-size: 18px;
	line-height: 1.5;
	letter-spacing: 0px;
	margin-left: auto;
	margin-right: auto;
	text-align: left;

	max-width: 90vw;
	width: 800px;

}
.wallMessageTag{
	white-space: nowrap;
}

.prayedForMessage, .prayForClick{
	font-weight: 400;
	font-style: normal;
	font-family: 'Roboto Condensed', sans-serif;
	color: #757474;
	font-size: 14px;
	line-height: 1.6;
	letter-spacing: 0px;
	

}

.wallDiv{
	margin-bottom: 20px;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

form{
	transition: opacity .5s ease;
}

button{
	background-color: #f0fdff;
	color: #8f8e8e;

	font-family: 'Roboto Condensed', sans-serif;
	cursor: pointer;
	font-size: 1.8rem;
	padding: 10px;

	margin-left: 3px;
	margin-right: 3px;

}

.buttonWrap{
	text-align: center;
}

button:hover{
	color: black;
}

button:disabled{
	opacity: .2;
	color: #8f8e8e;
	cursor: inherit;

}

.singleLineInput{
	color: #8f8e8e;
	width: 100%;
	font-size: 2rem;
	font-family: 'Roboto Condensed', sans-serif;
	border-left: none;
	border-top: none;
	border-right: none;
	border-bottom-color: #bcbcce;
/*	background-color: #f2f7fb5e;*/
	background: rgb(242,247,251);
	background: linear-gradient(0deg, rgba(242,247,251,0.37) 0%, rgba(242,247,251,0.37) 85%, rgba(242,247,251,0) 100%);

}

.singleLineInput:focus, .singleLineInput:hover{
	color: black;
}

.disabled{
	pointer-events: none;
	opacity: .2;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.list-enter-active,
.list-leave-active {
  transition: all 1s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

</style>